(function () {
    'use strict';
    var appConfig = Object.freeze({
        baseURL: 'http://localhost:8000/api/v1',
        loginPath: '/intradmin-login.html',
        homePath: '/intradmin.html'
    });

    window.appconfig = appConfig;
})();
